import { render, staticRenderFns } from "./BicGroupDetails.vue?vue&type=template&id=dff8f450&"
import script from "./BicGroupDetails.vue?vue&type=script&lang=js&"
export * from "./BicGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dff8f450')) {
      api.createRecord('dff8f450', component.options)
    } else {
      api.reload('dff8f450', component.options)
    }
    module.hot.accept("./BicGroupDetails.vue?vue&type=template&id=dff8f450&", function () {
      api.rerender('dff8f450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicGroupDetails.vue"
export default component.exports